import { Hero } from "../components/home/Hero";
import { Feature } from "../components/home/Feature";
import { FeatureTwo } from "../components/home/FeatureTwo";
import { Benefits } from "../components/home/Benefits";
import { Requisitos } from "../components/home/Requisitos";
import { Space } from "../components/home/Space";

// import TagManager from "../components/googleTag/TagManager";
import { useUtmTracking } from "../hooks/useUtmTracking";

export function HomePage() {
  useUtmTracking();

  return (
    <div>
      {/* <TagManager /> */}
      <Hero />
      <Requisitos />
      <Benefits />
      <Feature />
      <FeatureTwo />
      <Space />
    </div>
  );

}
